import { FormBase } from 'core/components';

export default class RestockDateForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'restockDate',
					label: 'RESTOCKDATE.DATE',
				},
				{
					name: 'scheduledRestockDate',
					label: 'RESTOCKDATE.SCHEDULEDRESTOCKDATE',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/RestockDateForm.js